import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: "",
    userInfo: {},
    openTabs: [],
    activeTab: ""
  },
  getters: {
    userToken(state) {
      return state.token;
    },
    userInfo(state) {
      return state.userInfo;
    },
    openTabs(state) {
      return state.openTabs;
    },
    activeTab(state) {
      return state.activeTab;
    }
  },
  mutations: {
    // 储存登录的用户信息
    saveLoginInfo(state, data) {
      sessionStorage.setItem("token", data.token)
      sessionStorage.setItem("user", JSON.stringify(data))
      state.token = data.token
      state.userInfo = data
    },
    // 刷新重新存储用户信息
    refreshUserMessage(state, user) {
      const token = sessionStorage.getItem("token") || ""
      state.token = token
      state.userInfo = user
    },
    // 移除用户信息
    removeLoginInfo(state) {
      sessionStorage.removeItem("token")
      sessionStorage.removeItem("user")
      state.token = ""
      state.userInfo = {}
      state.openTabs = []
      state.activeTab = "/SystemHome/projectInfo"
    },
    addTabs(state, data) {
      let index = state.openTabs.findIndex(i => i.name === data.name)
      if (index > 0) {
        state.openTabs[index] = data
      } else {
        state.openTabs.push(data)
      }
    },
    deleteTabs(state, route) {
      let index = 0
      for (let option of state.openTabs) {
        if (option.path === route) {
          break
        }
        index++
      }
      state.openTabs.splice(index, 1)
    },
    setActiveTab(state, data) {
      state.activeTab = data
    }
  },
  actions: {
  }
})
